import styled from 'styled-components';

import { breakpoints } from 'components';

export const StyledInputContainer = styled.div`
  display: grid;
  gap: 8px;
`;

export const StyledOptionsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: ${breakpoints.md}px) {
    grid-template-columns: 1fr;
    justify-items: center;
  }
`;
